import { useMemo } from 'react';
import { slugify } from '../utils/slugify';

/**
 * Extract headings from markdown content to generate table of contents
 * @param {string} content - Markdown content
 * @returns {Array} Array of heading objects with id, text, and level
 */
export const useTableOfContents = (content) => {
  const headings = useMemo(() => {
    if (!content) return [];

    const headingRegex = /^(#{2,3})\s+(.+)$/gm;
    const matches = [];
    let match;

    while ((match = headingRegex.exec(content)) !== null) {
      const level = match[1].length; // Number of # characters
      const text = match[2].trim();
      const id = slugify(text);

      // Only include H2 and H3 headings
      if (level === 2 || level === 3) {
        matches.push({
          id,
          text,
          level
        });
      }
    }

    return matches;
  }, [content]);

  return headings;
};